import React from 'react';
import { useMetronome } from '../contexts/MetronomeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';

const SoundSelector = () => {
  const { soundType, setSoundType } = useMetronome();
  const { t } = useLanguage();

  const soundOptions = [
    { id: 'woodblock', name: t('sounds.woodblock') },
    { id: 'click', name: t('sounds.click') },
    { id: 'drum', name: t('sounds.drum') },
    { id: 'bell', name: t('sounds.bell') }
  ];

  return (
    <motion.div 
      className="p-4 bg-white dark:bg-gray-900 rounded-lg shadow-md"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <h3 className="text-lg font-medium mb-4 text-gray-800 dark:text-gray-200">
        {t('soundSelection')}
      </h3>
      
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        {soundOptions.map(option => (
          <button
            key={option.id}
            className={`p-3 rounded-lg border ${
              soundType === option.id
                ? 'bg-indigo-100 border-indigo-300 text-indigo-700 dark:bg-indigo-900/50 dark:border-indigo-700 dark:text-indigo-300'
                : 'bg-gray-50 border-gray-200 text-gray-700 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-700'
            }`}
            onClick={() => setSoundType(option.id)}
            title={option.name}
          >
            <span className="block truncate">{option.name}</span>
          </button>
        ))}
      </div>
    </motion.div>
  );
};

export default SoundSelector;